<template>
  <div id="bulk-shipment-modal" role="dialog" data-backdrop="static" data-keyboard="false" class="bulk-review modal fade" @click.stop>
    <div class="modal-dialog modal-lg" @click.stop>
      <div class="modal-content">
        <div class="summary-box">
          <div class="flex gap-10">
            <strong>出荷データを{{ shippings.length }}件読み込みました</strong>
            <div class="flexbox gap-10">
              <span class="valid">✔ {{ validCount }} 成功</span>
              <span class="error">✖ {{ errorCount }} エラー</span>
            </div>
          </div>
          <div class="flexbox gap-10">
            <button type="button" class="btn btn-warning" @click="reUploadCSV">CSVアップロード</button>
            <button class="btn btn-primary" @click="submitSelected">
              確定 ({{ selectedShippings.length }})
            </button>
            <button type="button" class="btn" @click="close()">閉じる</button>
          </div>
        </div>
        <div v-if="overQuantityItems.length > 0 || duplicateRequestNos.length > 0" class="error-box">
          <div v-if="overQuantityItems.length > 0">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> 以下の商品の合計数量が在庫数を超えています
            <ul>
              <li v-for="(e, i) in overQuantityItems" :key="i">
                {{ e }}
              </li>
            </ul>
          </div>
          <div v-if="duplicateRequestNos.length > 0">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> 依頼番号が重複しています
            <ul>
              <li v-for="(e, i) in duplicateRequestNos" :key="i">
                {{ e }}
              </li>
            </ul>
          </div>
        </div>
        <div style="max-height: 70vh; overflow: auto;">
          <OrderCard
            v-for="shipping in shippings"
            :key="shipping.index"
            :order="shipping"
            :modelValue="selectedShippings"
            @update:modelValue="selectedShippings = $event"
            @validateAll="validateAll"
            @deleteShipping="deleteShipping"
          />
        </div>
      </div>
    </div>
    <modal-confirm
      v-if="openConfirmModal"
      :message="confirmMessage"
      @confirm="submitRegister"
      @close="closeModalConfirm"
    />
    <modal-alert
      v-if="openAlertModal"
      :message="addedMessage"
      :customHide="true"
      :modalWidth="550"
      @close="closeModalAlert"
    />
  </div>
</template>

<script>
import OrderCard from './OrderCard.vue'
import ModalConfirm from '@/components/ModalConfirm'
import ModalAlert from '@/components/ModalAlert'
import WarehouseAcrossService from '@/services/warehouseacrossservice'

export default {
  props: {
    shippings: {
      type: Array,
      default () {
        return []
      }
    }
  },
  components: {
    OrderCard,
    ModalConfirm,
    ModalAlert
  },
  data () {
    return {
      loader: null,
      selectedShippings: [],
      overQuantityItems: [],
      duplicateRequestNos: [],
      openConfirmModal: false,
      confirmMessage: '選択した注文を登録してもよろしいですか？',
      openAlertModal: false,
      total: 0,
      shippingCreated: []
    }
  },
  computed: {
    validCount () {
      return this.shippings.filter(o => o.valid).length
    },
    errorCount () {
      return this.shippings.filter(o => !o.valid).length
    },
    addedMessage () {
      if (this.shippingCreated.length > 0) {
        return `
          出荷情報（${this.total}件中${this.shippingCreated.length}件）を受け付けました。<br>
          出荷管理番号:<br>
          <ul>
            ${this.shippingCreated.map(i => `<li>${i.requestNo} / ${i.shippingNo} (${i.shippingId})</li>`).join('')}
          </ul>
          <div>
            ご登録頂いた情報は、納品状況照会画面より確認いただけます。<br>
            また、出荷が完了した際はメールにて通知させていただきます。<br>
          </div>
        `
      }
      return 'サーバは処理中にエラーが発生しました。再度ご確認ください。'
    }
  },
  methods: {
    close () {
      if (this.shippings.length > 0) {
        const answer = window.confirm('Changes you made may not be saved. Reload site?')
        if (answer) {
          this.$emit('close')
        }
      } else {
        this.$emit('close')
      }
    },
    closeModalConfirm () {
      $('#confirm-alert').modal('hide')
      this.openConfirmModal = false
    },
    closeModalAlert () {
      $('#myModal').modal('hide')
      this.openAlertModal = false
    },
    reUploadCSV () {
      this.$emit('close')
      this.$emit('openModalUpload')
    },
    deleteShipping (shipping) {
      this.$emit('deleteShippings', [shipping.index])
    },
    async submitSelected () {
      const valid = await this.validateAll()

      if (!valid) {
        this.$store.commit('toggleModal', {
          show: true,
          message: '入力内容にエラーがあります。確認してください。'
        })
        return false
      }

      this.openConfirmModal = true
    },
    async validateAll () {
      await Promise.all(
        this.shippings.map(s => this.validateShipping(s))
      )

      const requestNoMap = {}
      const duplicateRequestNos = new Set()
      this.duplicateRequestNos = []

      const itemTotals = {}
      const overItems = new Set()
      this.overQuantityItems = []

      let hasInvalidShipping = false

      this.selectedShippings.forEach(s => {
        // ===== check total quantity > acrossQuantity =====
        s.products.forEach(p => {
          const itemId = p.itemId
          const qty = Number(p.quantity) || 0
          const acrossQty = Number(p.acrossQuantity) || 0

          if (!itemTotals[itemId]) {
            itemTotals[itemId] = {
              total: 0,
              acrossQuantity: acrossQty
            }
          }

          itemTotals[itemId].total += qty
        })

        // check duplicate requestNo
        const key = s.requestNo.trim()
        if (key) {
          if (requestNoMap[key]) {
            duplicateRequestNos.add(key)
          } else {
            requestNoMap[key] = true
          }
        }

        if (!s.valid) {
          hasInvalidShipping = true
        }
      })

      if (duplicateRequestNos.size) {
        this.duplicateRequestNos = [...duplicateRequestNos]
      }

      Object.entries(itemTotals).forEach(([itemId, data]) => {
        if (data.total > data.acrossQuantity) {
          overItems.add(itemId)
        }
      })

      if (overItems.size) {
        this.overQuantityItems = [...overItems]
      }
      return !hasInvalidShipping && this.duplicateRequestNos.length === 0 && this.overQuantityItems.length === 0
    },
    async validateShipping (shipping) {
      shipping.errors = []

      const requiredFields = [
        { obj: shipping, key: 'requestNo', label: '依頼番号' },
        { obj: shipping, key: 'shippingName', label: '出荷名' },

        { obj: shipping.shipment, key: 'name', label: '発送元名' },
        { obj: shipping.shipment, key: 'postalCode', label: '郵便番号(発送元情報)' },
        { obj: shipping.shipment, key: 'address1', label: '住所1(発送元情報)' },
        { obj: shipping.shipment, key: 'phoneNo', label: '電話番号(発送元情報)' },

        { obj: shipping.delivery, key: 'name', label: 'お届け先名' },
        { obj: shipping.delivery, key: 'postalCode', label: '郵便番号(お届け先情報)' },
        { obj: shipping.delivery, key: 'address1', label: '住所1(お届け先情報)' },
        { obj: shipping.delivery, key: 'phoneNo', label: '電話番号(お届け先情報)' }
      ]

      requiredFields.forEach(f => {
        if (!f.obj[f.key] || f.obj[f.key].toString().trim() === '') {
          shipping.errors.push(`${f.label}は空にできません`)
        }
      })

      const minValidate = []
      const maxValidate = []
      if (shipping.products.length <= 0) {
        shipping.errors.push(
          '商品を選択してください。'
        )
      }
      shipping.products.forEach(p => {
        if (!p.quantity || Number(p.quantity) <= 0) {
          minValidate.push(p.itemId)
        }
        if (p.quantity > 0 && p.quantity > p.acrossQuantity) {
          maxValidate.push(p.itemId)
        }
      })
      if (minValidate.length > 0) {
        shipping.errors.push(
          `以下の商品IDの数量は1以上の数値を入力してください: ${minValidate.join(', ')}`
        )
      }
      if (maxValidate.length > 0) {
        shipping.errors.push(
          `以下の商品IDはACROSS在庫数以内で入力してください: ${maxValidate.join(', ')}`
        )
      }

      shipping.valid = shipping.errors.length === 0

      return shipping.valid
    },
    async submitRegister () {
      this.loader = this.$loading.show()
      await WarehouseAcrossService.bulkRegisterShippingMultichannel({shippings: this.selectedShippings})
        .then((response) => {
          this.closeModalConfirm()
          this.total = response.data.total
          this.shippingCreated = response.data.success
          const selectedIndexes = this.shippingCreated.map(i => i.index)
          this.$emit('deleteShippings', selectedIndexes)
          this.selectedShippings = []
          this.openAlertModal = true
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          // let logParams = {
          //   name: eventCode.warehouse_across.shipping_tab.multi_channel_shipping.click_request_shipping_btn,
          //   properties: {
          //     shippingNo: this.shippingNo,
          //     shippingId: this.shippingId
          //   }
          // }
          // EventService.postTrackLog(logParams)
          this.loader && this.loader.hide()
        })
    },
    handleBeforeUnload (event) {
      event.preventDefault()
      event.returnValue = ''
    }
  },
  async mounted () {
    await this.validateAll()
    $('#bulk-shipment-modal').modal('show')
    this.selectedShippings = this.shippings.filter(o => o.valid)
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  }
}
</script>

<style scoped>
.modal-open .modal {
  overflow: hidden;
}
#bulk-shipment-modal {
  .modal-lg {
    width: 90%;
    overflow: hidden;
    .modal-content {
      padding: 20px;
    }
  }
  .bulk-review {
    margin: auto;
  }
  .error-box {
    background: #fff3cd;
    padding: 10px;
    border-radius: 6px;
    margin-bottom: 15px;
    color: red;
  }
  .summary-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    padding: 12px;
    background: #ebf1fc;
    border: 1px solid #ddd;
    margin-bottom: 15px;
    border-radius: 6px;
  }
  .valid {
    color: #28a745;
    margin-left: 10px;
  }
  .error {
    color: #dc3545;
    margin-left: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/BulkShipmentReview.vue